import { createActions, createReducer } from 'reduxsauce'

import ConsultaEmpenhoCredorService from '../../servicos/ConsultaEmpenhoCredorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaEmpenhoCredorAquisicoesDiretasInicio: [],
    buscaConsultaEmpenhoCredorAquisicoesDiretasSucesso: ['consultaEmpenhoCredorAquisicoesDiretas'],
    buscaConsultaEmpenhoCredorAquisicoesDiretasErro: ['erro'],
    setSelecionadoConsultaEmpenhoCredorAquisicoesDiretasSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaEmpenhoCredorAquisicoesDiretas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaEmpenhoCredorAquisicoesDiretasInicio())
        let serv = new ConsultaEmpenhoCredorService()
        return serv
            .consultarAquisicoesDiretas(filtro)
            .then(response => dispatch(Creators.buscaConsultaEmpenhoCredorAquisicoesDiretasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaEmpenhoCredorAquisicoesDiretasErro(error)))
    }
}

const buscaConsultaEmpenhoCredorAquisicoesDiretasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaEmpenhoCredorAquisicoesDiretasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaEmpenhoCredorAquisicoesDiretasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaEmpenhoCredorAquisicoesDiretas.resultado,
        dataSincronizacaoDados: action.consultaEmpenhoCredorAquisicoesDiretas.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaEmpenhoCredorAquisicoesDiretas.fonte,
    }
}

const setSelecionadoConsultaEmpenhoCredorAquisicoesDiretasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS_INICIO]: buscaConsultaEmpenhoCredorAquisicoesDiretasInicio,
    [Types.BUSCA_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS_ERRO]: buscaConsultaEmpenhoCredorAquisicoesDiretasErro,
    [Types.BUSCA_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS_SUCESSO]: buscaConsultaEmpenhoCredorAquisicoesDiretasSucesso,
    [Types.SET_SELECIONADO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS_SUCESSO]: setSelecionadoConsultaEmpenhoCredorAquisicoesDiretasSucesso,
})
